import { Injectable } from '@angular/core';
import DictionaryStr from '../../../models/dictionary';
import { HttpService } from '../http.service';
import { HttpClient } from '@angular/common/http';
import { HttpConfiguration } from '../../../app.http.config';
import { RequestTypes } from '../../../models/enums/request-types.enum';
import BaseResponse from '../../../models/kartinatv-responses/base.response';
import { LoginResponse } from '../../../models/kartinatv-responses/client/login.response';
import AccountHttpService from '../internal/account.http.service';
import Login from '../../../login/models/login';
import { DeviceService } from '../../../services/device-service';
import { KartinaErrorsService } from '../../../services/kartina-errors-service';
import { CookieService } from 'angular2-cookie/core';

/**
 * Created by Sergey Shoshin on 2017-04-21.
 */

declare let window: any;

@Injectable()
export class KartinaTvHttpService extends HttpService {
    constructor(
        http: HttpClient,
        httpConfig: HttpConfiguration,
        private readonly accountRequester: AccountHttpService,
        private readonly deviceService: DeviceService,
        private readonly errorHandler: KartinaErrorsService,
        private readonly cookieService: CookieService) {
        super('', RequestTypes.KartinaApiProxy, httpConfig, http);
    }

    public async getAsync<T extends BaseResponse>(methodName: string, queryParams: DictionaryStr<string>, isRepeat = false): Promise<T> {
        const firstCall = () => this.getJsonAsync<T>(methodName, queryParams);
        const repeatCall = () => this.getAsync<T>(methodName, queryParams, true);
        return await this.methodAsync<T>(firstCall, repeatCall, isRepeat);
    }

    public async postJsonAsync<T extends BaseResponse>(methodName: string, queryParams: DictionaryStr<string>, isRepeat = false): Promise<T> {
        const firstCall = () => this.postAsync<T>(methodName, queryParams);
        const repeatCall = () => this.postJsonAsync<T>(methodName, queryParams, true);
        return await this.methodAsync<T>(firstCall, repeatCall, isRepeat);
    }

    protected async methodAsync<T extends BaseResponse>(method: Function, methodRepeat: Function, isRepeat = false): Promise<T> {
        const response = await method();
        if (!!response && !!response.error) {
            if (response.error.code === 12 || response.error.code === 11) {
                try {
                    // relogin
                    const login: Login = await this.accountRequester.getCredentialsAsync();
                    if (!!login && !!login.email && !!login.password) {
                        const params = new DictionaryStr<string>();
                        params['login'] = login.email;
                        params['pass'] = login.password;
                        params['softid'] = 'canada_WEBUI';
                        params['cli_serial'] = this.deviceService.getMac();
                        const loginRes = await this.getJsonAsync<LoginResponse>('v3/login', params);
                        if (loginRes.error && loginRes.error.type === 'E_CONTRACT_INACTIVE') {
                            const msg = 'Действие Вашей подписки приостановлено. Обратитесь в службу поддержки +1 (844) 477-8788';
                            this.errorHandler.updateMessage(msg);
                            return response;
                        }
                        await this.errorHandler.checkError(loginRes.error);
                        if (!isRepeat) {
                            return await methodRepeat();
                        } else {
                            const msg =
                                'Обратите внимание! У Вас не обнаружено подписок. <a href="/checkout">Подпишитесь</a> на один из пакетов, чтобы иметь возможность пользоваться услугами KartinaTV';
                            this.errorHandler.updateMessage(msg);
                        }
                    } else {
                        const msg =
                            'Обратите внимание! У Вас не обнаружено подписок. <a href="/checkout">Подпишитесь</a> на один из пакетов, чтобы иметь возможность пользоваться услугами KartinaTV';
                        this.errorHandler.updateMessage(msg);
                    }
                } catch (e) {
                    const msg =
                        'Обратите внимание! У Вас не обнаружено подписок. <a href="/checkout">Подпишитесь</a> на один из пакетов, чтобы иметь возможность пользоваться услугами KartinaTV';
                    this.errorHandler.updateMessage(msg);
                }
            } else if (response.error.code > 0) {
                await this.errorHandler.checkError(response.error);
            } else {
                throw new Error('Неизвестная ошибка!');
            }
        } else {
            this.cookieService.remove('system-message');
            this.errorHandler.updateMessage('');
        }
        return response;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/http/kartinatv/base.http.service.ts